import { CellGlobalActions } from '@components/organisms/Datatable/cells/CellGlobalActions';

const tableSchemaBase = [
	{
		accessor: 'entity',
		title: 'global.producer',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'name',
		title: 'global.name',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'technology',
		title: 'global.projectType',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'availableStock',
		title: 'global.availableStock',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'sellPrice',
		title: 'global.sellPriceLabel',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'unit',
		title: 'global.unit',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'active',
		title: 'global.status',
		sortable: true,
		type: 'activeStatus',
		defaultVisible: true,
	},
	{
		accessor: 'place',
		title: 'global.place',
		sortable: false,
		defaultVisible: false,
	},
	{
		accessor: 'siteCount',
		title: 'global.siteCount',
		sortable: false,
		defaultVisible: false,
	},
	{
		accessor: 'organization',
		title: 'global.organization',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'activatedBy',
		title: 'global.activatedBy',
		sortable: false,
		defaultVisible: false,
	},
	{
		accessor: 'activatedAt',
		title: 'global.activatedAt',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'createdAt',
		title: 'global.createdAt',
		sortable: true,
		defaultVisible: false,
	},

	{
		type: 'measurabilitiesActions',
		accessor: 'actions',
		title: <CellGlobalActions />,
		width: 50,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
